import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToResults from 'components/_special/HowToResults'
import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { biomeResults } from 'routes'

import bacteria from './assets/bacteria_curly.svg'
import { Image } from './styles'

/**
 * BHowResults
 *
 * @param {object} props - properties of component
 * @returns {node} BHowResults
 */
const BHowResults = props => {
  const { index, data, pathCdn, locale, isSquareHidden } = props
  const link = biomeResults.link(locale)
  const asPath = biomeResults.as(locale)
  const viewport = useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)

  return (
    <SectionWrapper isOverflowHidden={true} classNameInner="pb-2">
      <HowToResults
        viewport={viewport}
        index={index}
        title={data.title}
        content={data.content}
        link={link}
        asPath={asPath}
        buttonText={data.button}
        pathCdn={pathCdn}
        data={data.list}
        isSquareHidden={isSquareHidden}
        squareColor={colors.orange}
      />
      {!viewport.mobile && <Image alt="curly bacteria" src={bacteria} />}
    </SectionWrapper>
  )
}

BHowResults.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowResults.defaultProps = {
  isSquareHidden: false,
}

export default BHowResults
